import axios from "axios";
import Vue from "vue";
import Vuex from "axios";
import VueLocalStorage from "vue-localstorage";
Vue.use(VueLocalStorage);
Vue.use(Vuex);
let instance = null;
var BASE_URL = process.env.API_BASE;
var qs = require("qs");

const HTTP = axios.create({
  baseURL: BASE_URL,
  crossDomain: true,
  headers: {
    "X-Access-Token": Vue.localStorage.get("accessToken"),
    platform: "web",
    apiKey: Vue.localStorage.get("apiKey")
  }
});
class Service {
  constructor() {
    if (!instance) {
      instance = this;
    }
    return instance;
  }
  login(creds) {
    console.log(creds);

    return HTTP.post(`/user/login`, creds).then(response => {
      Vue.localStorage.set(
        "companyID",
        JSON.stringify(response.data.business.id)
      );
      Vue.localStorage.set("user", JSON.stringify(response.data.user));
      return response;
    });
  }
  updateHeaders(payload) {
    axios.defaults.headers.common["X-Access-Token"] = payload.token;
    axios.defaults.headers.common["apiKey"] = payload.apiKey;
    Vue.localStorage.set("accessToken", payload.token);
    Vue.localStorage.set("apiKey", payload.token);
  }
  postEdificios(objEdificio, id_business, namespace="maintenance") {
    return HTTP.post(`/business/${id_business}/buildings`, {
      name: objEdificio.nombre,
      address: objEdificio.direccion,
      namespace: namespace
    });
  }
  getEdificios(id_business, namespace="maintenance") {
    return HTTP.get(`/business/${id_business}/buildings?namespace=${namespace}`).then(response => {
      Vue.localStorage.set("edificios", JSON.stringify(response.data));
      return response;
    });
  }
  getEdificio(id_edificio, namespace="maintenance") {
    return HTTP.get(`/building/${id_edificio}?namespace=${namespace}`).then(response => {
      return response;
    });
  }
  delEdificio(id_edificio) {
    return HTTP.delete(`/building/${id_edificio}`).then(response => {
      return response;
    });
  }
  putEdificio(id_edificio, obj) {
    return HTTP.put(`/building/${id_edificio}`, {
      district: obj.district,
      status: obj.status,
      type: obj.type
    }).then(response => {
      return response;
    });
  }
  getDistrito() {
    return HTTP.get(`/district`).then(response => {
      return response;
    });
  }
  delUsuario(id_user, id_company) {
    console.log(id_user);
    return HTTP.delete(
      `/business/${id_company}/user/${id_user}`
    ).then(response => {
      return response;
    });
  }
  // postUser(obj){
  //     return HTTP.post(`/user/register`, {
  //         firstName: obj.firstname,
  //         lastName: obj.lastname,
  //         email: obj.email,
  //         password: obj.password,
  //         document: obj.document
  //     })
  // }
  // nuevo:
  postUser(id_business, obj, namespace = "maintenance") {
    return HTTP.post(`/business/${id_business}/users`, {
      firstName: obj.firstName,
      lastName: obj.lastName,
      email: obj.email,
      password: obj.password,
      document: obj.document,
      role: obj.role,
      status: obj.status,
      namespace: namespace
    });
  }
  putUser(id_business, id_user, obj) {
    return HTTP.put(`/business/${id_business}/user/${id_user}`, {
      firstName: obj.firstName,
      lastName: obj.lastName,
      email: obj.email,
      password: obj.password,
      document: obj.document,
      role: obj.role,
      status: obj.status
    });
  }
  getUsers(id_business, namespace) {
    return HTTP.get(`/business/${id_business}/users?namespace=${namespace}`).then(response => {
      Vue.localStorage.set("users", JSON.stringify(response.data));
      return response;
    });
  }
  getCompany(id_business) {
    return HTTP.get(`/business/${id_business}`).then(response => {
      // Vue.localStorage.set('company', JSON.stringify(response.data))
      return response;
    });
  }
  currentUser(id) {
    return HTTP.get(`/user/${id}`).then(response => {
      return response;
    });
  }
  getUserInCompany(id, id_business) {
    return HTTP.get(`business/${id_business}/user/${id}`).then(response => {
      return response;
    });
  }
  putCompany(id_business, obj) {
    var formData = new FormData();

    formData.append("name", obj.name);
    formData.append("image", obj.image);
    formData.append("hmenuColor", obj.hmenuColor);
    formData.append("hbodyColor", obj.hbodyColor);
    return HTTP.put(`/business/${id_business}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then(response => {
      return response;
    });
  }
  postCheckPoint(id_business, obj,namespace="maintenance") {
    var formData = new FormData();
    formData.append("name", obj.name);
    formData.append("image", obj.image);
    formData.append("location", obj.location);
    formData.append("description", obj.description);
    formData.append("autor", obj.author);
    formData.append("namespace", namespace);
    if(obj.typificationId){
      formData.append("typificationId", obj.typificationId);
    }
    if(namespace === 'experience'){
      formData.append("category", obj.category)
    }
    return HTTP.post(
      `/business/${id_business}/checkpoint`,
      formData
    ).then(response => {
      return response;
    });
  }
  putCheckPoint(id_business, id_checkpoint, obj) {
    var formData = new FormData();
    formData.append("name", obj.name);
    // formData.append('location', obj.location)
    formData.append("description", obj.description);
    if (obj.image) {
      formData.append("image", obj.image);
    }
    if(obj.typificationId){
      formData.append("typificationId", obj.typificationId);
    }
    return HTTP.put(
      `/business/${id_business}/checkpoint/${id_checkpoint}`,
      formData
    ).then(response => {
      return response;
    });
  }
  getCheckPoints(id_business, namespace="maintenance") {
    return HTTP.get(`/business/${id_business}/checkpoint?namespace=${namespace}`).then(response => {
      return response;
    });
  }

  getCheckPoint(id_company, id_checkpoint, namespace= 'maintenance') {
    return HTTP.get(
      `/business/${id_company}/checkpoint/${id_checkpoint}?namespace=${namespace}`
    ).then(response => {
      return response;
    });
  }
  deleteCheckPoint(id_company, id_checkpoint) {
    return HTTP.delete(
      `/business/${id_company}/checkpoint/${id_checkpoint}`
    ).then(response => {
      return response;
    });
  }
  getTasks(id_checkpoint) {
    return HTTP.get(`/checkpoint/${id_checkpoint}/task`).then(response => {
      return response;
    });
  }
  postTask(id_checkpoint, obj) {
    return HTTP.post(`/checkpoint/${id_checkpoint}/task`, {
      name: obj.name,
      labetype: obj.labeltype,
      type: obj.type,
      minRange: obj.minRange,
      maxRange: obj.maxRange
    }).then(response => {
      return response;
    });
  }
  putTask(id_checkpoint, id_task, obj) {
    return HTTP.put(`/checkpoint/${id_checkpoint}/task/${id_task}`, {
      name: obj.name,
      labeltype: obj.labeltype,
      type: obj.type,
      minRange: obj.minRange,
      maxRange: obj.maxRange
    }).then(response => {
      return response;
    });
  }
  deleteTask(id_task) {
    return HTTP.delete(`/task/${id_task}`).then(response => {
      return response;
    });
  }
  postAlternative(id_task, str) {
    return HTTP.post(`/task/${id_task}/alternative`, {
      value: str
    }).then(response => {
      return response;
    });
  }
  putAlternative(id_task, id_alter, str) {
    return HTTP.put(`/task/${id_task}/alternative/${id_alter}`, {
      value: str
    }).then(response => {
      return response;
    });
  }
  delAlternative(id_task, id_alter) {
    return HTTP.delete(
      `/task/${id_task}/alternative/${id_alter}`
    ).then(response => {
      return response;
    });
  }
  putLinkBuild(id_business, id_user, build) {
    return HTTP.put(`/business/${id_business}/user/${id_user}/linkbuilding`, {
      building: build
    }).then(response => {
      return response;
    });
  }
  delUnlinkBuild(id_business, id_user, build) {
    return HTTP.post(
      `/business/${id_business}/user/${id_user}/unlinkbuilding`,
      {
        building: build
      }
    ).then(response => {
      return response;
    });
  }
  getEdificiosDetallados(id_business, id_user) {
    return HTTP.get(
      `/business/${id_business}/user/${id_user}/buildingsfull`
    ).then(response => {
      return response;
    });
  }
  postCPLinkBuild(id_checkpoint, id_building) {
    return HTTP.post(
      `/checkpoint/${id_checkpoint}/building/${id_building}/link`
    ).then(response => {
      return response;
    });
  }
  delCPUnlinkBuild(id_checkpoint, id_building) {
    return HTTP.delete(
      `/checkpoint/${id_checkpoint}/building/${id_building}/unlink`
    ).then(response => {
      return response;
    });
  }
  putCPLinkBuild(id_checkpoint, id_building, payload) {
    var formdata = new FormData();
    if (payload.description) {
      formdata.append("description", payload.description);
    }
    if (payload.image) {
      formdata.append("image", payload.image);
    }
    return HTTP.put(
      `/checkpoint/${id_checkpoint}/building/${id_building}/link`,
      formdata
    ).then(response => {
      return response;
    });
  }
  postDashboard(id_business, obj, namespace='maintenance') {
    return HTTP.post(`/business/${id_business}/dashboard`, {
      startDate: obj.date,
      building: obj.building,
      checkpoint: obj.checkpoint,
      status: obj.status,
      namespace: namespace
    }).then(response => {
      return response;
    });
  }
  postDashboardIndicator(id_business, obj) {
    return HTTP.post(`/business/${id_business}/dashboard`, obj).then(response => {
      return response;
    });
  }
  postReport(id_business, obj) {
    return HTTP.post(`/business/${id_business}/dashboard/filter`, {
      startDate: obj.startDate,
      endDate: obj.endDate,
      building: obj.building,
      checkpoint: obj.checkpoint,
      task: obj.task
    }).then(response => {
      return response;
    });
  }
  getBusiness(id_business) {
    return HTTP.get(`/business/${id_business}`).then(response => {
      return response;
    });
  }
  getCheckPointsStats(payload) {
    return HTTP.post(
      `/business/${payload.bussines}/statistics/checkpoints`,
      payload
    )
      .then(response => {
        return response;
      })
      .catch(err => err.response);
  }
  getCheckPointStats(id_business, id_checkpoint, obj) {
    if (obj) {
      return HTTP.post(
        `/business/${id_business}/statistics/checkpoints/${id_checkpoint}`,
        {
          startDate: obj[0],
          endDate: obj[1]
        }
      ).then(response => {
        return response;
      });
    }
    return HTTP.post(
      `/business/${id_business}/statistics/checkpoints/${id_checkpoint}`
    ).then(response => {
      return response;
    });
  }
  getUsersStats(payload) {
    if (payload.obj) {
      return HTTP.post(`/business/${payload.id}/statistics/users/`, {
        startDate: payload.obj.startDate,
        endDate: payload.obj.endDate,
        namespace: payload.obj.namespace
      });
    }

    return HTTP.post(`/business/${payload.id}/statistics/users/`, {
      namespace: payload.namespace
    });
  }
  getUsersStatsIndicator(payload) {
    return HTTP.post(`/business/${payload.id}/statistics/users/`, payload.obj);
  }
  //
  getCheckPointBuildingStats(payload) {
    return HTTP.post(
      `/business/${payload.id}/statistics/checkpoints/${payload.checkpoint}/`,
      payload
    );
  }
  getBuildingsStats(payload) {
    return HTTP.post(`/business/${payload.id}/statistics/buildings/`, payload);
  }
  getUserHistoric(payload) {
    return HTTP.post(`/business/${payload.id}/statistics/usersdetail`, payload);
  }
  setTaskOrder(payload) {
    return HTTP.post(`/checkpoint/${payload.id}/ordertask`, {
      tasks: payload.tasks
    });
  }
  getBusiness() {
    return HTTP.get(`/business/`);
  }
  createBusiness(payload) {
    var formdata = new FormData();
    formdata.append("name", payload.name);
    formdata.append("username", payload.username);
    formdata.append("ruc", payload.ruc);
    formdata.append("address", payload.name);
    formdata.append("email", payload.email);
    if (payload.image) {
      formdata.append("image", payload.image.file);
    }
    formdata.append("hbodyColor", payload.hbodyColor);
    formdata.append("hmenuColor", payload.hmenuColor);
    formdata.append("timeSchedule", payload.timeSchedule);
    return HTTP.post(`/business/`, formdata);
  }
  updateBusiness(payload) {
    console.log(payload);

    var formdata = new FormData();
    formdata.append("name", payload.name);
    formdata.append("username", payload.username);
    formdata.append("ruc", payload.ruc);
    formdata.append("address", payload.address);
    formdata.append("email", payload.email);
    if (payload.image) {
      formdata.append("image", payload.image.file);
    }
    formdata.append("hbodyColor", payload.hbodyColor);
    formdata.append("hmenuColor", payload.hmenuColor);
    formdata.append("timeSchedule", payload.timeSchedule);
    return HTTP.put(`/business/${payload.id}`, formdata);
  }
  getBusinessView(payload) {
    return HTTP.get(`/business/${payload}`);
  }
  linkUserOwners(payload) {
    return HTTP.put(`/business/${payload.businessId}/linkowner`, payload);
  }
  unlinkUserOwners(payload) {
    return HTTP.delete(
      `/business/${payload.businessId}/linkowner?userId=${payload.userId}`
    );
  }
  getApiKey(payload) {
    return HTTP.get(`/business/getApiKey?username=${payload}`)
      .then(res => res)
      .catch(err => err.response);
  }
  createBusinessOwner(payload) {
    return HTTP.post(`/business/owners`, payload);
  }
  updateBusinessOwner(payload) {
    return HTTP.put(`business/owners/${payload.id}`, payload.data);
  }
  getBusinessOwners() {
    return HTTP.get(`business/owners`);
  }
  getBusinessOwnerDetail(payload) {
    return HTTP.get(`business/owners/${payload}`);
  }
  getBusinessAlerts(payload){
    let query = typeof payload.query === 'string' ? payload.query : "&"+qs.stringify(payload.query)
    return HTTP.get(`business/${payload.id}/warnings-history/mobile?namespace=${payload.namespace}${query}`)
  }
  getBusinessAlertsHistoric({id, namespace, query}){
    let querystring = typeof query === 'string' ? query : "&"+qs.stringify(query)
    console.log(querystring, query);
    
    return HTTP.get(`business/${id}/warnings-history?namespace=${namespace}${querystring}`)
  }
  getBusinessAlertsHistoricResume({id, namespace, query}){
    let querystring = typeof query === 'string' ? query : "&"+qs.stringify(query)
    console.log(querystring, query);
    
    return HTTP.get(`business/${id}/warnings-history/resume?namespace=${namespace}${querystring}`)
  }
  getBusinessAlertsHistoricDashboard({id, namespace, query}){
    let querystring = typeof query === 'string' ? query : "&"+qs.stringify(query)
    console.log(querystring, query);
    
    return HTTP.get(`business/${id}/warnings-history/dashboard?namespace=${namespace}${querystring}`)
  }
  getBusinessAlertsOld(payload){
    let query = typeof payload.query === 'string' ? payload.query : "&"+qs.stringify(payload.query)
    return HTTP.get(`business/${payload.id}/warnings-olds?namespace=${payload.namespace}${query}`)
  }
  closeBusinessAlertsOld({id, body}){
    console.log(body);
    return HTTP.post(`business/${id}/warnings-olds-close`, body);
  }
  getAlert({id}){
    return HTTP.get(`/warnings/${id}/`);
  }
  postComment({id, body}){
    return HTTP.post(`/warnings/${id}/comments`, body);
  }
  closeAlert({id, body}){
    console.log(id, body);
    return HTTP.put(`/warnings/${id}/close`, body);
  }
  downloadStatsCheckpoints({id, body}){
    return HTTP.post(`/business/${id}/statistics/checkpoints/exports`,body, {
      headers: {
        ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }
  checkpointTypefication({id, namespace}){
    return HTTP.get(`/business/${id}/checkpoint/typifications?namespace=${namespace}`);
  }
  uploadAttachment({file}){
    const formData = new FormData()
    formData.append('file_upload', file)
    return HTTP.post(`/attachments/upload`, formData);
  }
}
export const service = new Service();



// WEBPACK FOOTER //
// ./src/helper/Rest.js